<template lang="pug">
  .wrap(v-if="corporation")
    .sidebar.sidebar-company-show(:class="{ 'sidebar-fixed-sp': this.sidebarHidden }")
      .return-prev(v-if="fromMap")
        // a(@click="back") MAPに戻る
      .return-prev(v-if="fromJob")
        a(@click="back") 求人検索に戻る
      .return-prev(v-else)
        a(@click="back") 法人検索に戻る
      h4 法人情報
      ul
        li
          a(@click="pageScroll('company-show-section1')") 基本情報
        li
          a(@click="pageScroll('company-show-section2')") 出稿予算・掲載状況
    .main
      .company-show
        .company-show-header
          .point
            span.label(v-for="p in corporation.pr_point") {{ p }}
          h2.company_name
            | {{ corporation.corporate_name }}
          .company_url
            a(:href="corporation.corporate_url" target="_blank" rel="noopener noreferrer")
              | {{ corporation.corporate_url }}
        .company-show-body
          .company-show-section#company-show-section1
            h3 基本情報
              span 取得日：{{ corporation.acquisition_date }}
            .row
              .col.title
                | 法人ID
              .col
                | {{ corporation.corporate_number }}
            .row
              .col.title
                | 住所
              .col
                a.button-sub(
                  :href="googleMapUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  v-if="googleMapUrl")
                  | 拡大地図を表示
                span(v-html="corporatePlaceWithLineBreak") &nbsp;
            .row
              .col.title
                | 電話番号
              .col
                a.company_tel(:href="telLink" v-if="corporation.corporate_tel")
                  | {{ corporation.corporate_tel }}
            .row
              .col.title
                | 業種
              .col
                span(v-for="i in corporation.industry")
                  | {{ i }}
                  br
                | &nbsp;
            .row
              .col.title
                | 事業内容
              .col
                span(v-html="corporation.corporate_contents") &nbsp;
            .row
              .col-wrap
                .col.title
                  | 従業員数
                .col
                  | {{ corporation.employee_amount }}&nbsp;
                .col.title
                  | 設立
                .col
                  | {{ corporation.established }}&nbsp;
            .row
              .col-wrap
                .col.title
                  | 売上高
                .col
                  | {{ corporation.sales }}&nbsp;
                .col.title
                  | 資本金
                .col
                  | {{ corporation.capital }}&nbsp;
            .row
              .col-wrap
                .col.title
                  | 代表
                .col
                  | {{ corporation.president_name }}&nbsp;
                .col.title
                  | FAX
                .col
                  | {{ corporation.fax }}&nbsp;
            .row
              .col.title
                | メールアドレス
              .col
                span(v-if="corporation.mail_address" v-html="corporation.mail_address.join('<br/>')")
            .row
              .col.title
                | ブランド
              .col
                | {{ corporation.brand }}&nbsp;
          .company-show-section#company-show-section2
            h3 出稿予算・掲載状況
            .company-published-description
              | 当システムでは「中途メディアデータ：2018年5月〜」「APメディアデータ：2018年7月〜」を保有しております。
            h4 中途
            table.table
              tr
                th &nbsp;
                th 今月
                th
                  | 先月
                  br
                  span
                    | {{ this.getLastMonth() }}
                th
                  | 3ヶ月
                  br
                  span
                    | {{ this.getPeriodMonths(3) }}
                th
                  | 6ヶ月
                  br
                  span
                    | {{ this.getPeriodMonths(6) }}
                th
                  | 1年
                  br
                  span
                    | {{ this.getPeriodMonths(12) }}
              tr
                td.left 出稿予算
                td {{ corporation.budget_recruit_current_month }}<br class="only-sp" />万円
                td {{ corporation.budget_recruit_last_month }}<br class="only-sp" />万円
                td {{ corporation.budget_recruit_last_quarter }}<br class="only-sp" />万円
                td {{ corporation.budget_recruit_last_harf_year }}<br class="only-sp" />万円
                td {{ corporation.budget_recruit_last_year }}<br class="only-sp" />万円
              tr
                td.left 掲載状況
                td
                  | {{ corporation.published_jobs_recruit_media_current_month }}
                  <br class="only-sp" />求人
                td
                  | {{ corporation.published_jobs_recruit_media_last_month }}
                  <br class="only-sp" />求人
                td
                  | {{ corporation.published_jobs_recruit_media_last_quarter }}
                  <br class="only-sp" />求人
                td
                  | {{ corporation.published_jobs_recruit_media_harf_year }}
                  <br class="only-sp" />求人
                td
                  | {{ corporation.published_jobs_recruit_media_year }}
                  <br class="only-sp" />求人
              tr
                td.left 出稿<br class="only-sp" />メディア
                td
                  ul
                    li(v-for="m in corporation.published_recruit_media_name_current_month") {{ m }}
                td
                  ul
                    li(v-for="m in corporation.published_recruit_media_name_last_month") {{ m }}
                td
                  ul
                    li(v-for="m in corporation.published_recruit_media_name_last_quarter") {{ m }}
                td
                  ul
                    li(v-for="m in corporation.published_recruit_media_name_harf_year") {{ m }}
                td
                  ul
                    li(v-for="m in corporation.published_recruit_media_name_year") {{ m }}
            h4 AP
            table.table
              tr
                th &nbsp;
                th 今月
                th
                  | 先月
                  br
                  span
                    | {{ this.getLastMonth() }}
                th
                  | 3ヶ月
                  br
                  span
                    | {{ this.getPeriodMonths(3) }}
                th
                  | 6ヶ月
                  br
                  span
                    | {{ this.getPeriodMonths(6) }}
                th
                  | 1年
                  br
                  span
                    | {{ this.getPeriodMonths(12) }}
              tr
                td.left 出稿予算
                td {{ corporation.budget_ap_current_month }}<br class="only-sp" />万円
                td {{ corporation.budget_ap_last_month }}<br class="only-sp" />万円
                td {{ corporation.budget_ap_last_quarter }}<br class="only-sp" />万円
                td {{ corporation.budget_ap_last_harf_year }}<br class="only-sp" />万円
                td {{ corporation.budget_ap_last_year }}<br class="only-sp" />万円
              tr
                td.left 掲載状況
                td
                  | {{ corporation.published_jobs_ap_media_current_month }}
                  <br class="only-sp" />求人
                td
                  | {{ corporation.published_jobs_ap_media_last_month }}
                  <br class="only-sp" />求人
                td
                  | {{ corporation.published_jobs_ap_media_last_quarter }}
                  <br class="only-sp" />求人
                td
                  | {{ corporation.published_jobs_ap_media_harf_year }}
                  <br class="only-sp" />求人
                td
                  | {{ corporation.published_jobs_ap_media_year }}
                  <br class="only-sp" />求人
              tr
                td.left 出稿<br class="only-sp" />メディア
                td
                  ul
                    li(v-for="m in corporation.published_ap_media_name_current_month") {{ m }}
                td
                  ul
                    li(v-for="m in corporation.published_ap_media_name_last_month") {{ m }}
                td
                  ul
                    li(v-for="m in corporation.published_ap_media_name_last_quarter") {{ m }}
                td
                  ul
                    li(v-for="m in corporation.published_ap_media_name_harf_year") {{ m }}
                td
                  ul
                    li(v-for="m in corporation.published_ap_media_name_year") {{ m }}


    Footer
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import { HumanErrorMessages } from '../constants'
  import mapGetSet from '../libs/map-get-set'
  import corporation from '../store/modules/corporation'
  import Footer from './parts/Footer'

  export default {
    components: { Footer },
    data () {
      return {
        sidebarHidden: false,
        fromMap: this.$route.query.from === 'map',
        fromJob: this.$route.query.from === 'job',
      }
    },
    mounted () {
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    },
    beforeMount () {
      if (!this.$store.state.corporation.detail) {
        this.$store.dispatch('common/pushToastError', {
          error: new Error(HumanErrorMessages.NO_DATA),
        })
        setTimeout(() => {
          this.$router.go(-1)
        }, 3000)
      }
    },
    async asyncData ({ store, route: { query: { id } } }) {
      if (!id) {
        return
      }
      await store.dispatch('corporation/fetchDetail', { id })
    },
    computed: {
      ...mapState({
        corporation: state => state.corporation.detail,
        user: state => state.user.detail,
        meta: state => state.route.meta,
      }),
      ...mapGetters('common', ['spMode']),
      googleMapUrl () {
        if (this.corporatePlaceWithoutZipCode) {
          return `https://maps.google.com/maps?q=${this.corporatePlaceWithoutZipCode}`
        }
        return ''
      },
      telLink () {
        return `tel:${this.corporation.corporate_tel}`
      },
      corporatePlaceWithLineBreak () {
        if (!this.corporation.corporate_place) {
          return ''
        }
        return this.corporation.corporate_place.replace(/^(〒[0-9-]+)/g, '$1<br/>')
      },
      corporatePlaceWithoutZipCode () {
        if (!this.corporation.corporate_place) {
          return ''
        }
        return this.corporation.corporate_place.replace(/^(〒[0-9-]+)/g, '')
      },
      ...mapGetSet({
        _this: this,
        get: ($vm, $s, k) => $s.state.corporation[k],
        set: ($vm, $s, k, v) => $s.commit(`corpooration/${k}`, v),
        keys: Object.keys(corporation.state),
      }),
    },
    methods: {
      back () {
        this.$router.go(-1)
      },
      getLastMonth () {
        const now = new Date()
        const last = new Date(now.getFullYear(), now.getMonth() - 1, 1)
        return `(${last.getFullYear() - 2000}/${last.getMonth() + 1})`
      },
      getPeriodMonths (months) {
        const now = new Date()
        const beforeDate = new Date(now.getFullYear(), now.getMonth() - months, 1)
        const before = `${beforeDate.getFullYear() - 2000}/${beforeDate.getMonth() + 1}`
        const afterDate = new Date(now.getFullYear(), now.getMonth() - 1, 1)
        const after = `${afterDate.getFullYear() - 2000}/${afterDate.getMonth() + 1}`
        return `(${before}〜${after})`
      },
      pageScroll (id) {
        document.getElementById(id).scrollIntoView()
      },
      handleScroll () {
        if (this.spMode) {
          this.sidebarHidden = (window.scrollY > 60)
        } else {
          this.sidebarHidden = false
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/CorporationDetail.vue